import CustomTagCell from '../CustomTagCell'
import { CellInfo } from '../types'

export const TagIdCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    meta: { onTagUpdate },
  } = info
  return (
    <CustomTagCell
      tagId={profileData.tagId}
      onTagUpdate={newTagId => onTagUpdate(profileData.profileId, newTagId, profileData?.profileType)}
    />
  )
}
